import ActionTile from './ActionTile';

// The "Connect a Data Source" tile shown at the top of the workspace landing,
// section, and document-type-detail pages. Links to the unfiltered /sources/add
// flow, where the user picks any app or document source. `redirectTo` is the
// absolute path that flow should return to. Logos are a mix of apps and storage
// so the single button reads as "any kind of source".
export default function ConnectSourceButton({ redirectTo }: { redirectTo: string }) {
  return (
    <ActionTile
      to={`/sources/add?redirect=${encodeURIComponent(redirectTo)}`}
      logos={['xero', 'drive', 'hubspot']}
      title="Connect a Data Source"
      subtitle="Xero, Google Drive, HubSpot, SharePoint, and more"
    />
  );
}
